export const GET_PUBLISHER_EVENT = 'GET_PUBLISHER_EVENT';
export const GET_PROPERTIES = 'GET_PROPERTIES';
export const GET_INTEGRATION_PUB_SETTINGS = 'GET_INTEGRATION_PUB_SETTINGS';
